function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3076 11.6979C9.85191 11.6979 9.49156 12.0521 9.49156 12.5C9.49156 12.9375 9.85191 13.3021 10.3076 13.3021H16.6666V18.2813C16.6666 20.8333 14.5576 22.9167 11.9504 22.9167H6.78898C4.19239 22.9167 2.08331 20.8438 2.08331 18.2917V6.71876C2.08331 4.15626 4.20298 2.08334 6.79958 2.08334H11.9716C14.5576 2.08334 16.6666 4.15626 16.6666 6.70834V11.6979H10.3076ZM20.4481 8.89605L23.4898 11.9273C23.646 12.0836 23.7294 12.2815 23.7294 12.5002C23.7294 12.7086 23.646 12.9169 23.4898 13.0627L20.4481 16.094C20.2919 16.2502 20.0835 16.3336 19.8856 16.3336C19.6773 16.3336 19.4689 16.2502 19.3127 16.094C19.0002 15.7815 19.0002 15.2711 19.3127 14.9586L20.9794 13.3023H16.6669V11.6981H20.9794L19.3127 10.0419C19.0002 9.72938 19.0002 9.21897 19.3127 8.90647C19.6252 8.58355 20.1356 8.58355 20.4481 8.89605Z",
  fill: "white"
});
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.156848b88faa62a6959cd642efbfbc0c.svg";
export { ForwardRef as ReactComponent };